module.exports = __webpack_public_path__ + "static/media/listDevices.dd07e90a.png";